import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../utils/api";
import { API_ENDPOINTS } from "../constants/api";
import "./ForgotPassword.css";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [resetUrl, setResetUrl] = useState("");
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError("");
    setMessage("");
    setResetUrl("");
    setIsSubmitting(true);

    try {
      const response = await api.post(API_ENDPOINTS.AUTH.FORGOT_PASSWORD, {
        email,
      });

      if (!response.ok) {
        const apiError = response?.data?.message || "Could not create reset link.";
        setError(apiError);
        return;
      }

      setMessage(
        response?.data?.message ||
          "If an account exists for this email, a password reset link has been generated."
      );

      if (response?.data?.resetUrl) {
        setResetUrl(response.data.resetUrl);
      }
    } catch (requestError) {
      setError(requestError.message || "Network error while creating reset link.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="forgot-page">
      <div className="forgot-card">
        <h1>Forgot Password</h1>
        <p>Enter your email and we will generate a reset link.</p>

        <form onSubmit={handleSubmit}>
          <label htmlFor="email">Email Address</label>
          <input
            id="email"
            type="email"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            placeholder="you@example.com"
            required
            disabled={isSubmitting}
          />

          {error && <div className="forgot-error">{error}</div>}
          {message && <div className="forgot-message">{message}</div>}

          {resetUrl && (
            <div className="forgot-reset-link-box">
              <div className="forgot-reset-label">Reset link:</div>
              <a href={resetUrl}>{resetUrl}</a>
            </div>
          )}

          <button
            type="submit"
            disabled={isSubmitting}
          >
            {isSubmitting ? "Creating link..." : "Create reset link"}
          </button>
        </form>

        <Link
          to="/"
          className="forgot-back-link"
        >
          Back to sign in
        </Link>
      </div>
    </div>
  );
};

export default ForgotPassword;
